var map = {
	"./font_anzu.png": "PaJJ",
	"./font_beautiful.png": "Gpon",
	"./font_darts.png": "Kyp1",
	"./font_genshin.png": "Qzez",
	"./font_hui.png": "Zoog",
	"./font_uzura.png": "aw46"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fWXm";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male ^\.\/font_.*\.png$
// module id = fWXm
// module chunks = 0